export default "__VITE_ASSET__f44522a4__"